import type { DeleteCausesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteCausesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteCauses = createMutationHook({
  name: 'deleteCauses',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.cause.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  invalidate: (trpc) => [
    trpc.frontend.cause.register.queryKey(),
    trpc.frontend.cause.getById.queryKey(),
    trpc.frontend.cause.getByParentIssueId.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.cause.causeCount.queryKey(),
  ],
  mapResponse: (result: { deletedCount: number }): DeleteCausesMutation => ({
    delete_cause: {
      __typename: 'cause_mutation_response',
      affected_rows: result.deletedCount,
    },
  }),
  graphqlDocument: DeleteCausesDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['cause', 'cause_aggregate'],
});
